<template>
  <div class="dx-choose-new-game dx-choose-players">
    <div v-if="hasGameGroups" class="dx-choose-players__game-players-type">
      <p>
        <span :class="gamePlayerTypeClasses('myGroups')" @click="setGameGroups">{{ $t('myGroups') }}</span>
        {{ $t('or') }}
        <span :class="gamePlayerTypeClasses('randomPlayers')" @click="setCustom">{{ $t('randomPlayers') }}</span>
      </p>
    </div>
    <div v-if="showGameGroups">
      <div class="row no-gutters">
        <div
          class="col-sm-4"
          v-for="group in gameGroups"
          :key="group.id"
          >
          <div
            @click="setGameGroup(group)"
            :class="gameGroupClasses(group)"
            >
            <h3 class="dx-choose-players__game-group__name">
              {{ group.name }}
              <small>
                ({{ group.players.length }})
              </small>
            </h3>
            <div class="dx-choose-players__game-group__players">
              <ul class="list-unstyled">
                <li v-for="player in group.players" :key="player.id">
                  {{ player.user.nickname }}
                </li>
              </ul>
            </div>
            <small class="dx-choose-players__game-group__invalid-group" v-if="!validGroup(group)">
              {{ $t('itRequiresAtLeastThreePeopleInTheGroup') }}
            </small>
          </div>
        </div>
      </div>
      <div class="dx-choose-players__avatars" v-if="!loading">
        <div class="row no-gutters">
          <div class="col-2 col-sm-1" v-for="(item, index) in avatars" :key="index">
            <dx-avatar
              :name="item.name"
              :nickname="item.user.nickname"
              @click.native="avatarClick(index)"
              />
          </div>
        </div>
      </div>
    </div>
    <div v-if="showCustom">
      <p class="subtitle">{{ $t('choosePlayerNumbers') }}</p>
      <div class="dx-choose-new-game__options">
        <dx-button
          v-for="number in options"
          :key="number"
          :default="number !== players"
          :info="number === players"
          large
          @click.native="onChange(number)"
          >
          {{ number }}
        </dx-button>
      </div>
      <div class="dx-choose-players__avatars" v-if="!loading">
        <div class="row no-gutters">
          <div class="col-2 col-sm-1" v-for="(item, index) in avatars" :key="index">
            <dx-avatar :name="item.name" @click.native="avatarClick(index)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { DxButton, DxAvatar } from './'
export default {
  name: 'dx-choose-players',
  components: { DxButton, DxAvatar },
  data () {
    return {
      options: [3, 4, 5, 6, 7, 8, 9, 10],
      players: 3,
      loading: true,
      selectedGameGroup: null,
      gameType: 'randomPlayers'
    }
  },
  methods: {
    ...mapActions([
      'setRandomUniqueAvatars',
      'setRandomPlayerAvatar',
      'loadGameGroups'
    ]),
    onChange (players) {
      this.players = players
      this.setRandomUniqueAvatars(players)
      this.$emit('change', this.players)
    },
    avatarClick (index) {
      this.loading = true
      this.setRandomPlayerAvatar(index).then(() => {
        this.loading = false
      })
      this.$emit('avatar-click', index)
    },
    getAvatar (index) {
      return this.avatars[index]
    },
    setGameGroups () {
      this.gameType = 'myGroups'
    },
    setCustom () {
      this.gameType = 'randomPlayers'
    },
    gameGroupClasses (group) {
      return {
        'dx-choose-players__game-group': true,
        'dx-choose-players__game-group--active': group.id === this.selectedGameGroup,
        'dx-choose-players__game-group--invalid': !this.validGroup(group)
      }
    },
    setGameGroup (group) {
      this.selectedGameGroup = group.id
      this.players = group.players.length
      this.setRandomUniqueAvatars(group.players)
      this.$emit('change', this.players)
    },
    gamePlayerTypeClasses (type) {
      return {
        active: type === this.gameType
      }
    },
    validGroup (group) {
      return group.players.length > 2
    }
  },
  computed: {
    ...mapGetters({
      avatars: 'getPlayerAvatars',
      gameGroups: 'getValidGameGroups',
      loggedIn: 'getLoggedIn'
    }),
    hasGameGroups () {
      return this.gameGroups.length > 0
    },
    showCustom () {
      return this.gameType === 'randomPlayers'
    },
    showGameGroups () {
      return this.gameType === 'myGroups'
    }
  },
  created () {
    this.setRandomUniqueAvatars(this.players).then(() => {
      this.loading = false
    })
    if (this.loggedIn) {
      this.loadGameGroups().then(() => {
        let groups = this.gameGroups.filter(i => this.validGroup(i))
        if (groups.length > 0) {
          this.setGameGroups()
          this.setGameGroup(groups[0])
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DxChoosePlayers.vue